<template>
  <div class="bg-white p-3 rounded">
    <div class="">
      <ValidationObserver ref="formChangeStatus" v-slot="{}" tag="form">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="reason"
            :label="getText"
            :maxlength="500"
            show-char-count
            :count-classes="['d-block text-right']"
            :error="errors[0]"
            :custom-error-msg="getValidationText"
          />
        </validation-provider>
      </ValidationObserver>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <action-button
        type="button"
        text="Cancelar"
        i="fa fa-times-circle"
        variant="outline-danger"
        class="ml-2 px-4 mb-3"
        @click="close()"
      />
      <action-button
        type="button"
        text="Guardar"
        i="fa fa-save"
        variant="success"
        class="ml-2 px-4 mb-3"
        @click="save()"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomTextArea from "CustomTextArea";
import { changeStatus } from "@/services/studentVisualImpairments.js";
import mixAlert from "@/mixin/alert.mixin";

export default {
  name: "StatusTimeline",
  components: {
    ActionButton,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [mixAlert],
  data: () => ({ reason: null }),
  props: {
    id: {
      type: Number,
      default: () => null
    },
    statusId: {
      type: Number,
      default: () => null
    },
    text: {
      type: String,
      default: () => ""
    },
    history: { type: Array, default: () => [] }
  },
  methods: {
    close() {
      this.reason = null;
      this.$emit("close");
    },
    async save() {
      const isFormValid = await this.$refs.formChangeStatus.validate();
      if (!isFormValid) return;
      try {
        const payload = {
          id: this.id,
          reason: this.reason,
          statusId: this.statusId
        };
        await changeStatus(payload);
        this.ShowToast(
          "",
          "La información ha sido guardada exitosamente",
          "success"
        );
        this.reason = null;
        this.$emit("saved");
      } catch (error) {
        this.ShowToast(
          "Error",
          error?.response?.data?.message ?? error?.message,
          "error"
        );
      }
    }
  },
  computed: {
    getText() {
      return "Razón para " + this.text + ":";
    },
    getValidationText() {
      return "Razón para " + this.text + " es requerido.";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";
.title {
  font-size: 16px;
  font-weight: bold;
  color: map-get($colors, "gray-12");
}
.event-date {
  font-weight: bold;
  font-size: 15px;
  color: #11291b;
  opacity: 1;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text {
  font-size: 16px;
  color: $black_2;
}
.text-small {
  font-size: 14px;
}

.actionButton {
  border-radius: 19px;
}
</style>
